import { Preferences } from './WebPreferences';

export const REMOVE_ADS_SKU = '';

export async function getAdsRemoved() { return true; }
export async function setAdsRemoved(val) {
  await Preferences.set({ key: 'adsRemoved', value: val ? 'true' : 'false' });
}
export async function initIAP() {}
export async function getProductPrice() { return null; }
export async function purchaseRemoveAds(onSuccess, onFailed) { onSuccess(); }
